module.exports = __webpack_public_path__ + "static/img/IAN_HEALY.0d51a7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IAN_HEALY.jpg
// module id = FFJK
// module chunks = 0